import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import { Layout, Card, Progress, Typography, Row, Col, Button, message, Spin } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../api/auth';

const { Header, Content } = Layout;


const PLAN_LIMIT = {
  free: { minutes: 0, subtitleCreates: 30, subtitleEdits: 100, ruleCreates: 10 },
  pro:  { minutes: 400, subtitleCreates: 300, subtitleEdits: 1000, ruleCreates: 100 },
};

function calcRemain(user, field){
  const planLimit = PLAN_LIMIT[user.plan]?.[field] ?? 0;
  const extra = user.extra?.[field] || 0;
  const used = user.usage?.[field] || 0;
  return { remain: planLimit + extra - used, total: planLimit + extra };
}

export default function PlanPage({ user: initialUser }){
  const navigate = useNavigate();
  const [user,setUser] = useState(initialUser || null);
  const [loading,setLoading]=useState(true);
  const { t } = useTranslation();

  useEffect(()=>{
    if(!initialUser){
      (async()=>{
        const data = await getCurrentUser();
        if(data.user) setUser(data.user);
        setLoading(false);
      })();
    }else{
      setLoading(false);
    }
  },[initialUser]);

  if(loading){
    return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}><Spin size="large"/></div>;
  }
  if(!user){
    return <div style={{padding:40,textAlign:'center'}}>未登录</div>;
  }
  const planKey = (user.plan || '').toLowerCase();
  const fields = [
    { key:'minutes', label:t('plan.minutes') },
    { key:'subtitleCreates', label:t('plan.subtitleCreates') },
    { key:'subtitleEdits', label:t('plan.subtitleEdits') },
    { key:'ruleCreates', label:t('plan.ruleCreates') },
  ];


  const upgrade = ()=>message.info(t('plan.upgrade'));
  const cancel = ()=>message.info(t('plan.cancel'));

  return (
    <Layout className="layout">
      <Header style={{ background:'#001529',padding:'0 24px',display:'flex',alignItems:'center' }}>
        <Button 
          icon={<HomeOutlined />} 
          onClick={()=>navigate('/dashboard')} 
          style={{background:'#fff',borderRadius:4,marginRight:16}}
        >{t('title.dashboard')}</Button>
        <div style={{marginLeft:'auto'}}><LanguageSelector/></div>
        <Typography.Title level={3} style={{color:'#fff',margin:0}}>{t('title.plan')}</Typography.Title>
      </Header>
      <Content style={{padding:24}}>
        <Card bordered={false} style={{maxWidth:1200,margin:'0 auto', width:'100%'}}>
          <Typography.Title level={4}>{t('plan.current')}: {user.plan || 'N/A'}</Typography.Title>
          <Typography.Text type="secondary">{t('plan.expires')}: {user.planExpiresAt? new Date(user.planExpiresAt).toLocaleDateString():'----'}</Typography.Text>
          <div style={{marginTop:16,marginBottom:24}}>
            {planKey==='free'?<Button type="primary" onClick={upgrade}>{t('plan.upgrade')}</Button>:<Button danger onClick={cancel}>{t('plan.cancel')}</Button>}
          </div> 
          <Row gutter={[32,24]} justify="space-between">
            {fields.map(f=>{
              const {remain,total} = calcRemain(user,f.key);
              const percent = total===0?0:Math.round(((total-remain)/total)*100);
              return (
                <Col xs={24} sm={12} md={12} lg={11} xl={11} key={f.key}>
                  <Card size="small" style={{background:'#f6f9fc'}}>
                    <Typography.Text>{f.label}</Typography.Text>
                    <Progress percent={percent} strokeColor={percent<90?"#1890ff":"#faad14"} showInfo={false}/>
                    <div style={{textAlign:'right',fontSize:12}}>{remain} / {total}</div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Card>
      </Content>
    </Layout>
  );
}
